<template>
  <li>
    <div class="product_img">
      <span
        v-if="checkbox"
        class="form_element-checkbox"
      >
        <input
          :id="item.item_sku"
          v-model="checked"
          type="checkbox"
          @change="onChange"
        >
        <label
          :for="item.item_sku"
          class="sp_chk focus"
        >선택</label>
      </span>
      <a
        :href="item.outlink"
        target="_blank"
      ><img :src="productImageUrl"></a>
    </div>
    <div class="product_text_info">
      <p class="product_title">
        <a
          :href="item.outlink"
          target="_blank"
        ><span>{{ item.item_name }}</span></a>
      </p>
      <div class="hashtag_list">
        <template v-for="hash in hashList">
          <span :key="hash">#{{ hash }} </span>
        </template>
      </div>
      <template >
     <!-- S : 20220530 밸런스 위드인 이뮤니티일 때만 노출되는 영역 -->
    <div class="pack-guide" v-if="item.item_sku=='303765K' || item.item_sku=='314475K'">
          <span>연질캡슐 제품과 함께 선택 시 별도 포장됨</span>
      <div class="promotion price-tip tooltip-a">
          <div class="promotion-tip">
              <button type="button" class="tooltip-btn" v-on:click="isTooltipShow=!isTooltipShow">제품보기</button>
          </div>
          <div class="promotion-tip-alert promotion-tip-alert-display" v-show="isTooltipShow">
              <em>연질캡슐 제품 :</em> 카로틴 플러스, 뉴트리 마린 오메가3, 오메가-3 밸런스, 비디에이치에이 블렌드, 코큐텐, 지엘에이 블렌드, 징코엠, 쏘팔메토 블렌드, 씨엘에이, 비젼 헬스
          </div>
      </div>
    </div>
    <!-- E : 20220530 밸런스 위드인 이뮤니티일 때만 노출되는 영역 -->
    </template>
    </div>
    <div class="quantity">
      <template v-if="isDoubleX(item.item_sku)">
        <p>1일 권장량:{{ item.recm_tab * 3 }}{{ item.display }} ({{ item.recm_tab }}세트)</p>
      </template>
      <template v-else>
        <p>1일 권장량:{{ item.recm_tab }}{{ item.display }}</p>
      </template>
      <span class="form_select-default">
        <select
          v-model="selectedCount"
          class="form_select"
          @change="onChange"
        >
          <option
            v-for="n in optionRange"
            :key="n"
            :value="n"
          >{{ n }}</option>
        </select>
        <span class="division_txt">{{ item.display }}</span>
      </span>
    </div>
  </li>
</template>
<script>
import { log } from '@/utils/common';
import { ASSETS_IMAGE_THUMBS_PATH } from '@/utils/constants';
import doubleXMixin from '@/components/global/doublex-mixin';


export default {
  name: 'ProductItem',
  mixins: [doubleXMixin],
  props: {
    imgUrl: {
      type: String,
      default: '/',
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    checkbox: {
      type: Boolean,
      default: false,
    },
    eventBus: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedCount: -1,
      checked: false,
      isTooltipShow:false,      // display:none v-show로 적용했을 시, 기본값 적용
    };
  },
  computed: {
    productImageUrl() {
      return `${ASSETS_IMAGE_THUMBS_PATH}/${this.item.item_sku}.jpg`;
    },
    // productOutlinkUrl() {
    //   return ;
    // },
    hashList() {
      return this.item.explain.split('#').filter((n) => n.length > 0);
    },
    optionRange() {
      const range = [];
      // for (let i = this.item.min_tab; i <= this.item.max_tab; ++i) range.push(i);

      let i = this.item.min_tab;
      if (this.$route.path.match(/step2\/*$/)) {
        i = 0; // step2 에서는 0 부터 선택 가능하게
      }

      if (this.isDoubleX(this.item.item_sku)) {
        for (; i <= this.item.max_tab; ++i) range.push(i * 3);
      } else {
        for (; i <= this.item.max_tab; ++i) range.push(i);
      }

      return range;
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'item.selectedCount': function () {
      this.selectedCount = this.item.selectedCount;
    },
  },
  created() {
    // eslint-disable-next-line no-nested-ternary
    this.selectedCount = this.item.selectedCount !== undefined
      ? this.item.selectedCount
      : this.isDoubleX(this.item.item_sku)
        ? this.item.recm_tab * 3 : this.item.recm_tab;

    if (this.eventBus) {
      this.eventBus.$on('set-item-state', (payload) => {
        if (payload.item_sku === this.item.item_sku) {
          log('ProductItem::created', 'i got a ', payload, this);
          this.selectedCount = payload.count;
          this.checked = payload.selected;

          this.onChange();
        }
      });
    }
  },
  methods: {
    onChange() {
      let evtType;
      if (this.checkbox) {
        evtType = 'change';
      } else {
        evtType = 'dose-change';
      }
      this.$emit(evtType, {
        item_sku: this.item.item_sku,
        item_name: this.item.item_name,
        checked: this.checked,
        selectedCount: this.selectedCount,
        seq: this.item.seq,
        price: this.isDoubleX(this.item.item_sku) ? this.item.price / 3 : this.item.price
      });
    },
  },
};
</script>
